import { useQuery } from "@tanstack/react-query";
import { ONE_DAY, convertToErrorMsg, jsonReviverFunction } from "./_base";
import { RemovalArea } from "../types/RemovalArea";
import { RemovalDate } from "../types/RemovalDate";

export const useRemovalDatesQuery = (from: Date, to: Date, removalAreas: RemovalArea[]) => {
    const query = useQuery<RemovalDate[], Error>({
        queryKey: ['removalDates', removalAreas.map(r => r.id).join('-'), from.toDateString(), to.toDateString()],
        refetchOnWindowFocus: true,
        staleTime: ONE_DAY,
        queryFn: () => getRemovalDates(from, to, removalAreas)
    })
    return query;
}

const getRemovalDates = async (from: Date, to: Date, removalAreas: RemovalArea[]): Promise<RemovalDate[]> => {
    const removalDates: RemovalDate[] = [];
    const dateFormat = new Intl.DateTimeFormat('en');
    const fromParam = dateFormat.format(from);
    const toParam = dateFormat.format(to);
    for (let i=0; i < removalAreas.length; i++) {
        const removalArea = removalAreas[i];
        const response = await fetch(`/api/removalAreas/${removalArea.id}/emptying-dates?from=${fromParam}&to=${toParam}`);
        const responseBody = await response.text();
        if (!response.ok) {
            const errorMsg = convertToErrorMsg(response.status, responseBody);
            throw errorMsg;
        } else {
            const responseJson = JSON.parse(responseBody, jsonReviverFunction);
            if (removalDates.length === 0) {
                removalDates.push(...responseJson as RemovalDate[]);
            } else {
                (responseJson as RemovalDate[]).forEach(date => {
                    if (!removalDates.some(d => d.originalDate.toDateString() === date.originalDate.toDateString())) {
                        removalDates.push(date);
                    }
                });
            }
        }
    }
    return removalDates;
}
